import { useTranslation } from "react-i18next";
import { useOfferPerformance } from "src/data/admin/queries/analytics";
import { DateRangeParams } from "src/data/admin/types/analytics";
import { OfferPerformanceTable } from "./OfferPerformanceTable";

export const DealPerformanceSection = ({ range }: { range: DateRangeParams }) => {
  const { t } = useTranslation();

  const { data } = useOfferPerformance(range);
  const deals = data?.deals;

  if (!deals || deals.rows.length === 0) return null;

  return (
    <OfferPerformanceTable
      title={t("analytics.offerPerformance.dealsTitle")}
      rows={deals.rows}
      totals={deals.totals}
    />
  );
};
